import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAirline } from "../../api/apiAirlines";
import parseError from "../../utils/parseError";

const useRestoreAirline = () => {
    const queryClient = useQueryClient();

    const { mutate: restoreAirlineAction, isPending } = useMutation({
        mutationFn: restoreAirline,
        onSuccess: (res) => {
            const message = res?.message || "Airline restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["airlines"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore airline");
        },
    });

    return { restoreAirline: restoreAirlineAction, isPending };
};

export default useRestoreAirline;
